import React, { useCallback, useEffect, useMemo, useState } from "react";
import ComboService from "../../services/ComboService";
import ComboCouponExtensionsTab from "../Combo/ComboCouponExtensionsTab";

interface Props {
  data: any[];
}

const comboService = new ComboService();

const extractExtensionId = (row: any): number | null => {
  const candidateIds = [
    row?.expiryExtensionRequestId,
    row?.referenceId,
  ];
  for (const candidate of candidateIds) {
    const parsed = Number(candidate);
    if (!Number.isNaN(parsed) && parsed > 0) return parsed;
  }
  return null;
};

const normalizeDetailsResponse = (payload: any) => {
  if (payload?.data?.id) return payload.data;
  if (payload?.id) return payload;
  return null;
};

const CouponExpiryExtensionForHouses = ({ data }: Props) => {
  const [detailsById, setDetailsById] = useState<Record<number, any>>({});
  const [loading, setLoading] = useState(false);

  console.log(data, "data in CouponExpiryExtensionForHouses")

  const extensionIds = useMemo(() => {
    const ids = data.map((row) => extractExtensionId(row)).filter(Boolean) as number[];
    return Array.from(new Set(ids));
  }, [data]);

  const loadDetails = useCallback(async () => {
    if (!extensionIds.length) {
      setDetailsById({});
      return;
    }

    setLoading(true);
    try {
      const results = await Promise.all(
        extensionIds.map(async (id) => {
          try {
            const response = await comboService.getExpiryExtensionRequestById(id);
            return { id, details: normalizeDetailsResponse(response) };
          } catch (e) {
            return { id, details: null };
          }
        }),
      );

      const mapped: Record<number, any> = {};
      results.forEach((item) => {
        mapped[item.id] = item.details;
      });
      setDetailsById(mapped);
    } finally {
      setLoading(false);
    }
  }, [extensionIds]);

  useEffect(() => {
    loadDetails();
  }, [loadDetails]);

  const extensionRequests = useMemo(() => {
    return extensionIds
      .map((id) => detailsById[id])
      .filter((item) => Boolean(item));
  }, [detailsById, extensionIds]);

  return (
    <ComboCouponExtensionsTab
      extensionRequests={extensionRequests}
      isLoading={loading}
      onRefreshData={loadDetails}
      title="Coupon Extensions"
    />
  );
};

export default CouponExpiryExtensionForHouses;
